import React, { useState } from "react"
import { useNavigate } from "react-router"
import useTitle from "@/hooks/useTitle"
import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic"
import PulseLoader from "react-spinners/PulseLoader"
import Modal from "@/components/common/modal/Modal"
import {
  useGetAccountContactMapsQuery,
  useDeleteAccountContactMapMutation,
} from "./accountContactMapsApiSlice"

const EtDeleteAccountContactMap = ({ id, setActiveAdminView }) => {
  useTitle("Delete Account Contact Map")

  return (
    <EtDeleteAccountContactMapForm
      id={id}
      setActiveAdminView={setActiveAdminView}
    />
  )
}

const EtDeleteAccountContactMapForm = ({ id, setActiveAdminView }) => {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [deleteMode, setDeleteMode] = useState("soft")

  const [deleteAccountContactMap, { isLoading, isError, error }] =
    useDeleteAccountContactMapMutation()

  const handleOpenModal = mode => {
    setDeleteMode(mode)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => setIsModalOpen(false)

  const handleConfirm = async e => {
    e.preventDefault()

    try {
      await deleteAccountContactMap({ id, deleteMode }).unwrap()

      if (setActiveAdminView) {
        setActiveAdminView("accountContactMaps")
      } else {
        navigate("/accountContactMaps")
      }
    } catch (error) {
      console.error(error)
    } finally {
      handleCloseModal()
    }
  }

  const handleCancel = () => {
    if (setActiveAdminView) {
      setActiveAdminView("accountContactMaps")
    } else {
      navigate("/accountContactMaps")
    }
  }

  return (
    <div className="bg-gray-200 p-1 w-3/4 mx-auto mt-5 rounded-lg shadow-md shadow-black">
      {isLoading && <PulseLoader color={"#ea580c"} />}

      {isError && (
        <p className="text-orange-700 font-semi-bold py-2">
          {error?.data?.message}
        </p>
      )}

      <div className="bg-white p-1 m-1 rounded">
        <p className="p-1 m-1 font-bold font-poppins text-xl">
          Delete Account Contact Map Entry
        </p>

        <div className="bg-gray-200 rounded m-1 p-1">
          <div className="bg-orange-50 border border-orange-200 rounded m-1 p-2">
            <p className="text-xs text-orange-700">
              You can either deactivate this Contact Map entry or permanently delete it.
              If hard deleted, any contacts reporting to this entry will have their reports-to field cleared.
            </p>
          </div>

          <div id="accountContactMaps" className="bg-white m-1 px-1 py-3 rounded">
            <EtBtnFormBasic
              name={"Make Inactive"}
              type={"clear"}
              handleClick={() => handleOpenModal("soft")}
            />

            <EtBtnFormBasic
              name={"Hard Delete"}
              type={"create"}
              handleClick={() => handleOpenModal("hard")}
            />

            <EtBtnFormBasic
              name={"Cancel"}
              type={"cancel"}
              handleClick={handleCancel}
            />
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
      />
    </div>
  )
}

export default EtDeleteAccountContactMap